import { getBalanceTypeById, getMemberBalances } from '@vista-digital/occ-domain'

export const hasMemberSpendingPoints = (): boolean =>
    getMemberBalances()?.some(memberBalance => {
        const paymentConversionRate = getBalanceTypeById(memberBalance.balanceTypeId)?.paymentConversionRate
        return memberBalance.availableUnits > 0 && paymentConversionRate !== undefined && paymentConversionRate > 0
    }) ?? false
